import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitishirdicabs() {



const cardData = {
  keyword: "Mumbai to Shirdi Cabs",
  heading: "Lotus Cab: Mumbai to Shirdi Cabs",

  headingDescription:
    "Lotus Cabs offers reliable and affordable Mumbai to Shirdi Cabs for Sai Baba Darshan, family pilgrimages, spiritual tours, corporate travel, airport transfers, and one-way or round-trip journeys. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Mumbai, well-maintained vehicles, and safe highway travel, Lotus Cabs ensures a comfortable, convenient, and hassle-free journey to Shirdi. Whether you are planning a same-day return, overnight stay, or a customized temple tour, our cab service is designed to make your pilgrimage smooth, safe, and memorable.",

  top: "Top Places to Visit in Shirdi with Lotus Cab",

 topPlaces: [
    {
        title: "Sai Baba Samadhi Temple",
        description:
            "Sai Baba Samadhi Temple is the heart of Shirdi and one of India's most visited pilgrimage destinations. Millions of devotees travel from Mumbai every year to seek the blessings of Shri Sai Baba and participate in Kakad Aarti, Madhyan Aarti, Dhoop Aarti, and Shej Aarti. The peaceful spiritual atmosphere, well-organized darshan facilities, and sacred Samadhi make it the most important destination of every Mumbai to Shirdi cab journey."
    },
    {
        title: "Dwarkamai",
        description:
            "Dwarkamai is the historic mosque where Sai Baba spent a major part of his life serving devotees and spreading the message of faith and compassion. The sacred Dhuni (eternal fire), Baba's stone seat, and several preserved artifacts continue to attract pilgrims who wish to experience the divine presence and rich spiritual heritage associated with Sai Baba."
    },
    {
        title: "Chavadi",
        description:
            "Chavadi holds great religious importance as Sai Baba used to sleep here on alternate nights during the later years of his life. Today, devotees visit this sacred place to witness the preserved wooden chair, palki, and historical belongings of Sai Baba while learning about the traditions that continue during the weekly Chavadi procession."
    },
    {
        title: "Gurusthan",
        description:
            "Gurusthan is believed to be the place where Sai Baba was first seen meditating beneath a neem tree. The temple complex features the sacred neem tree, Shiva Lingam, and marble statue of Sai Baba, making it one of the most spiritually significant places visited by devotees during their Shirdi pilgrimage."
    },
    {
        title: "Lendi Baug",
        description:
            "Lendi Baug is a serene garden personally maintained by Sai Baba during his lifetime. The peaceful pathways, ancient trees, sacred Nanda Deep (ever-burning lamp), and calm surroundings offer devotees a place for quiet prayer, meditation, and reflection after visiting the Samadhi Temple."
    },
    {
        title: "Khandoba Temple",
        description:
            "Khandoba Temple is one of the first places Sai Baba visited upon arriving in Shirdi. It was here that the village priest Mahalsapati welcomed him by addressing him as 'Sai,' a name that became known around the world. The temple remains an important part of every Shirdi pilgrimage itinerary."
    },
    {
        title: "Sai Heritage Village",
        description:
            "Sai Heritage Village beautifully recreates scenes from Sai Baba's life through life-sized sculptures, traditional village settings, devotional exhibits, and interactive displays. Families and children especially enjoy exploring this attraction while gaining a deeper understanding of Sai Baba's teachings and daily life."
    },
    {
        title: "Shani Shingnapur",
        description:
            "Located about 70 kilometers from Shirdi, Shani Shingnapur is one of Maharashtra's most famous pilgrimage destinations dedicated to Lord Shani. The village is renowned for its unique tradition of homes without doors and attracts devotees seeking protection, prosperity, and relief from planetary influences. Many travelers from Mumbai include Shani Shingnapur along with their Shirdi Darshan."
    },
    {
        title: "Sai Teerth Theme Park",
        description:
            "Sai Teerth Theme Park is India's first devotional theme park dedicated to Sai Baba. Featuring immersive multimedia shows, cultural exhibits, educational displays, and entertaining attractions for all age groups, it offers visitors a unique blend of spirituality, technology, and family entertainment during their stay in Shirdi."
    },
    {
        title: "Wet N Joy Water Park",
        description:
            "Wet N Joy Water Park is one of the largest amusement and water parks near Shirdi, offering exciting water slides, wave pools, family rides, children's play areas, and recreational activities. Families traveling from Mumbai often extend their pilgrimage with a fun-filled visit, making the overall journey enjoyable for both adults and children."
    }
],

  services: [
    {
      name: "Mumbai to Shirdi One Way Cab",
      description:
        "Our Mumbai to Shirdi one-way cab service is ideal for devotees who need a drop facility without return travel charges. This option helps reduce overall travel cost while ensuring comfortable and safe transportation. Professional drivers handle highway driving with care and experience. AC sedans and SUVs provide relaxed seating for long-distance travel. Pickup is available from any location across Mumbai. Transparent per-km pricing ensures clarity in billing. Suitable for individual pilgrims and family travel. Lotus Cab guarantees punctual pickup and smooth drop at Shirdi temple."
    },
    {
      name: "Mumbai to Shirdi Round Trip Taxi",
      description:
        "Round-trip taxi from Mumbai to Shirdi offers complete travel convenience for devotees planning return the same or next day. Flexible return scheduling allows darshan and sightseeing without rush. Vehicles remain available as per your waiting plan. Comfortable interiors ensure stress-free long-distance travel. Ideal for family groups and senior citizens. Transparent fare structure avoids hidden costs. Professional drivers ensure safe highway driving. Lotus Cab ensures smooth round-trip pilgrimage experience."
    },
    {
      name: "Affordable Cab Mumbai to Shirdi",
      description:
        "Affordable Mumbai to Shirdi cab service provides budget-friendly pilgrimage travel without compromising comfort or safety. Competitive per-km rates help manage travel expenses effectively. Clean AC vehicles and trained drivers enhance journey quality. Suitable for small families and solo travelers. Flexible booking options available 24/7. No hidden charges policy ensures cost transparency. Ideal for weekend or urgent temple visits."
    },
    {
      name: "Luxury Cab Mumbai to Shirdi",
      description:
        "Luxury cab service offers premium travel comfort for devotees seeking executive-level transportation. High-end vehicles ensure spacious interiors and superior seating comfort. Ideal for VIP guests and corporate spiritual tours. Professional chauffeurs provide smooth driving and courteous service. Perfect for long-distance relaxed highway travel."
    },
    {
      name: "SUV Cab Mumbai to Shirdi",
      description:
        "SUV cab is suitable for larger families and group pilgrims traveling together. Extra luggage capacity supports comfortable temple travel. AC comfort and stable highway performance ensure safe journey."
    },
    {
      name: "Same Day Return Cab Mumbai to Shirdi",
      description:
        "Same-day return cab service is ideal for quick darshan trips. Early morning departure and evening return options available. Drivers coordinate travel timing efficiently."
    },
    {
      name: "Corporate Cab Mumbai to Shirdi",
      description:
        "Corporate cab service available for group spiritual visits and company pilgrimage programs. Professional drivers and punctual service guaranteed."
    },
    {
      name: "Online Booking Mumbai to Shirdi",
      description:
        "Instant online booking system allows easy reservation with quick confirmation. 24/7 support team assists with travel coordination."
    }
  ],

  tableData: [
    ["Mumbai to Shirdi Cabs", "Mumbai to Shirdi One Way Cab"],
    ["Mumbai to Shirdi Round Trip Taxi", "Affordable Cab Mumbai to Shirdi"],
    ["Luxury Cab Mumbai to Shirdi", "SUV Cab Mumbai to Shirdi"],
    ["Sedan Taxi Mumbai to Shirdi", "Family Trip Cab Mumbai to Shirdi"],
    ["Corporate Cab Mumbai to Shirdi", "Weekend Trip Taxi Mumbai to Shirdi"],
    ["AC Cab Mumbai to Shirdi", "Online Booking Mumbai to Shirdi"],
    ["Best Outstation Cab Mumbai to Shirdi", "Per Km Rate Mumbai to Shirdi"],
    ["Same Day Return Cab Mumbai to Shirdi", "Group Tour Cab Mumbai to Shirdi"]
  ],

  whychoose: [
    { WhyChooseheading: "Experienced Highway Drivers", WhyChoosedescription: "Professionally trained drivers ensure safe and smooth long-distance travel." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-km fare with no hidden charges." },
    { WhyChooseheading: "24/7 Availability", WhyChoosedescription: "Round-the-clock booking and travel support." },
    { WhyChooseheading: "Clean AC Vehicles", WhyChoosedescription: "Well-maintained and sanitized vehicles for comfortable travel." },
    { WhyChooseheading: "Flexible Travel Options", WhyChoosedescription: "One-way, round-trip, and same-day return available." },
    { WhyChooseheading: "Multiple Vehicle Options", WhyChoosedescription: "Sedan, SUV, and luxury vehicles available." },
    { WhyChooseheading: "Doorstep Pickup", WhyChoosedescription: "Pickup available from any location in Mumbai." },
    { WhyChooseheading: "Reliable Service", WhyChoosedescription: "Punctual and professional pilgrimage transport service." }
  ]
};



const faqData = [
  { question: "How long does Mumbai to Shirdi travel take?", answer: "The journey usually takes 5–6 hours depending on traffic and road conditions." },
  { question: "Is same-day return possible?", answer: "Yes, we provide same-day return packages." },
  { question: "Is AC available in all vehicles?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Do you provide SUV options?", answer: "Yes, spacious SUV vehicles are available." },
  { question: "Is pricing per km transparent?", answer: "Yes, we provide clear per-km rate before booking." },
  { question: "Is online booking available?", answer: "Yes, instant booking support is available." },
  { question: "Is waiting charge applicable?", answer: "Waiting charges apply only for extended delays beyond package terms." },
  { question: "Can I customize return time?", answer: "Yes, return schedule is flexible." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate group bookings are available." },
  { question: "Are vehicles sanitized?", answer: "Yes, all vehicles are cleaned and sanitized regularly." }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Kulkarni",
    feedback:
      "Booked Mumbai to Shirdi round-trip cab with Lotus Cab. Excellent service, punctual driver, and very comfortable journey. Highly recommended for pilgrimage travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Deshpande",
    feedback:
      "We traveled with family to Shirdi temple. The SUV was spacious and clean. Smooth highway driving and transparent pricing. Great experience.",
    rating: 5
  }
];


























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Shirdi Cabs",
"image": "https://lotuscab.com/assets/images/mumbai-to-shirdi-cabs.jpg",
"description": "Book Mumbai to Shirdi Cabs with Lotus Cab for safe, comfortable, and affordable pilgrimage travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with experienced drivers for a smooth temple journey.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7821"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-to-shirdi-cabs"
}
};














  return (
    <div>
<Helmet>
  <title>Mumbai to Shirdi Cabs | One Way & Round Trip Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai to Shirdi Cabs with Lotus Cab for safe and comfortable pilgrimage travel. One way and round trip taxi service with Sedan, SUV, and AC cabs, professional drivers, instant booking, and 24x7 support for Shirdi Sai Baba Darshan."
/>

<meta
 name="keywords"
 content="Mumbai to Shirdi Cabs, Mumbai to Shirdi Taxi, Shirdi Cab from Mumbai, Mumbai Shirdi Cab Service, One Way Cab Mumbai to Shirdi, Round Trip Cab Mumbai to Shirdi, Mumbai to Shirdi Darshan Cab, Shirdi Sai Baba Cab Mumbai, Affordable Mumbai to Shirdi Cab, Cheap Mumbai to Shirdi Taxi, Online Mumbai to Shirdi Cab Booking, Sedan Cab Mumbai to Shirdi, SUV Cab Mumbai to Shirdi, Best Mumbai to Shirdi Cab, Lotus Cab Mumbai Shirdi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitishirdicabs;